export const defaultState = {
  country: null,
  id: null,
  memberAssociation: null,
  initials: '',
  name: '',
  cbHeadName: '',
  cbHeadEmail: '',
  cbHeadTelephone: '',
  contactName: '',
  contactEmail: '',
  contactTelephone: '',
  vatId: '',
  isActive: true,

  address: null,
  invoiceAddress: null,
  invoiceAddressSame: true,
  cisUsers: [],

  certificationBodyLevelDomains: [],

  lcAgreementSigned: false,
  lcAgreementSignedAt: null,
  deltaAgreementSigned: false,
  deltaAgreementSignedAt: null,
  iso9001AccreditationSigned: false,
  iso9001AccreditationSignedAt: null,
  iso17024AccreditationSigned: false,
  iso17024AccreditationSignedAt: null,
  lcValidationSigned: false,
  lcValidationSignedAt: null,

  cctAgreementSigned: false,
  cctAgreementSignedAt: null,
};

const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_EDIT_DATA) {
    return {
      ...state,
      ...action.payload,
      address: { ...action.payload.address, country: action.payload.address?.country?.id },
      country: action.payload.country?.id,
      memberAssociation: action.payload.memberAssociation?.id,
      remoteAssociations: action.payload.memberAssociation?.remoteAssociations || [],
      certificationBodyLevelDomains:
        action.payload.certificationBodyLevelDomains?.map(
          (item) => item.certificateLevelDomain?.id,
        ) || [],
      lcAgreementSignedAt: action.payload.lcAgreementSignedAt
        ? new Date(action.payload.lcAgreementSignedAt)
        : null,
      lcValidationSignedAt: action.payload.lcValidationSignedAt
        ? new Date(action.payload.lcValidationSignedAt)
        : null,
      deltaAgreementSignedAt: action.payload.deltaAgreementSignedAt
        ? new Date(action.payload.deltaAgreementSignedAt)
        : null,
      iso9001AccreditationSignedAt: action.payload.iso9001AccreditationSignedAt
        ? new Date(action.payload.iso9001AccreditationSignedAt)
        : null,
      iso17024AccreditationSignedAt: action.payload.iso17024AccreditationSignedAt
        ? new Date(action.payload.iso17024AccreditationSignedAt)
        : null,
      cctAgreementSignedAt: action.payload.cctAgreementSignedAt
        ? new Date(action.payload.cctAgreementSignedAt)
        : null,
    };
  }
  if (action.type === UPDATE_FIELD) {
    return {
      ...state,
      [action.payload.name]: action.payload.value,
      ...(action.payload.value === false && {
        lcAgreementSignedAt:
          action.payload.name === 'lcAgreementSigned' ? null : state.lcAgreementSignedAt,
        lcValidationSignedAt:
          action.payload.name === 'lcValidationSigned' ? null : state.lcValidationSignedAt,
        deltaAgreementSignedAt:
          action.payload.name === 'deltaAgreementSigned' ? null : state.deltaAgreementSignedAt,
        iso9001AccreditationSignedAt:
          action.payload.name === 'iso9001AccreditationSigned'
            ? null
            : state.iso9001AccreditationSignedAt,
        iso17024AccreditationSignedAt:
          action.payload.name === 'iso17024AccreditationSigned'
            ? null
            : state.iso17024AccreditationSignedAt,
        cctAgreementSignedAt:
          action.payload.name === 'cctAgreementSigned' ? null : state.cctAgreementSignedAt,
      }),
    };
  }

  return state;
}
